<form *ngIf="form" [formGroup]="form" (submit)="save()" [ngClass]="{'invalid-submit': invalidSubmit}">
  <div class="Loyalty ui-g-12 ui-md-12 ui-lg-12">
    <div class="ui-g">
      <div class="ui-g-9 ui-md-9 ui-lg-9">
        <h1 class="step-title">{{fields.title}}</h1>
      </div>
      <div class="ui-g-3 ui-md-3 ui-lg-3 form-button-row">
        <button pButton class="k-generic-btn" type="button" icon="fa fa-arrow-left" iconPos="left" routerLink="/loyalty/selfscanrules" label="{{ 'common.back' | translate }}"></button>
        <button pButton class="k-generic-btn" (click)="save()" type="button" icon="fa fa-floppy-o" iconPos="left" label="{{'common.save' | translate}}"></button>
      </div>
    </div>
    <div class="card">
      <div class="ui-g ui-fluid">

        <div class="ui-g-12 ui-md-4">
          <span class="label" [ngClass]="{'required': !validationSelfScan.division_sales_network_id.nullable}">{{ validationSelfScan.division_sales_network_id.keyName }}</span>
          <p-dropdown [options]="divisionSales" formControlName="division_sales_network_id"></p-dropdown>
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="form" [validation]="validationSelfScan.division_sales_network_id"></app-validation-msg>
        </div>

        <div class="ui-g-12 ui-md-4">
          <span class="label" [ngClass]="{'required': !validationSelfScan.description.nullable}">{{ validationSelfScan.description.keyName }}</span>
          <input type="text" pInputText class="fieldInput" formControlName="description"/>
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="form" [validation]="validationSelfScan.description"></app-validation-msg>
        </div>

      </div>
      <div class="ui-g ui-fluid">

        <div class="ui-g-12 ui-md-4">
          <span class="label" [ngClass]="{'required': !validationSelfScan.date_start.nullable}">{{ validationSelfScan.date_start.keyName }}</span>
          <app-kv-calendar
          #dateStartField
          [inputName]="'date_start'"
          [formData]="form"
          [startDateSelector]="true"
          [endDateInputName]="'date_end'"
          [endDateCalendar]="dateEndField"
          [defaultDate]="defaultStartDate"
          [defaultValue]="defaultStartDate">
          </app-kv-calendar>
          <app-validation-msg [arrayValidators]="[validators.checkDateMajorOther_dateStart]" [(fireInvalidSubmit)]="invalidSubmit" [form]="form" [validation]="validationSelfScan.date_start"></app-validation-msg>
        </div>

        <div class="ui-g-12 ui-md-4">
          <span class="label" [ngClass]="{'required': !validationSelfScan.date_end.nullable}">{{ validationSelfScan.date_end.keyName }}</span>
          <app-kv-calendar
          #dateEndField
          [inputName]="'date_end'"
          [formData]="form"
          [endDateSelector]="true"
          [startDateInputName]="'date_start'"
          [startDateCalendar]="dateStartField"
          [defaultDate]="defaultEndDate"
          [defaultValue]="defaultEndDate">
          </app-kv-calendar>
          <app-validation-msg [arrayValidators]="[validators.checkDateMinorOther_dateEnd]" [(fireInvalidSubmit)]="invalidSubmit" [form]="form" [validation]="validationSelfScan.date_end"></app-validation-msg>
        </div>

      </div>

      <div class="ui-g ui-fluid">
          <div class="ui-g-12">
            <hr>
            <h3 class="title">{{ fields.chk_panel }}</h3>
          </div>

          <div class="ui-g-12 ui-md-4">
            <span class="label" [ngClass]="{'required': !validationSelfScan.chk_min_num.nullable}">{{ validationSelfScan.chk_min_num.keyName }}</span>
            <input type="number" min="0" max="{{paramSelfScan.chk_min_num}}" pInputText class="fieldInput" formControlName="chk_min_num"/>
            <app-validation-msg [arrayValidators]="[validators.decimalNotNegative,validators.chk_min_num]" [(fireInvalidSubmit)]="invalidSubmit" [form]="form" [validation]="validationSelfScan.chk_min_num"></app-validation-msg>
          </div>

          <div class="ui-g-12 ui-md-4">
            <span class="label" [ngClass]="{'required': !validationSelfScan.chk_max_num.nullable}">{{ validationSelfScan.chk_max_num.keyName }}</span>
            <input type="number" min="0" max="{{paramSelfScan.chk_max_num}}" pInputText class="fieldInput" formControlName="chk_max_num"/>
            <app-validation-msg [arrayValidators]="[validators.decimalNotNegative,validators.chk_max_num]" [(fireInvalidSubmit)]="invalidSubmit" [form]="form" [validation]="validationSelfScan.chk_max_num"></app-validation-msg>
          </div>
      </div>

      <div class="ui-g ui-fluid">
        <div class="ui-g-12 ui-md-4">
          <span class="label" [ngClass]="{'required': !validationSelfScan.tx_interval.nullable}">{{ validationSelfScan.tx_interval.keyName }}</span>
          <input type="number" min="0" max="{{paramSelfScan.tx_interval}}" pInputText class="fieldInput" formControlName="tx_interval"/>
          <app-validation-msg [arrayValidators]="[validators.decimalNotNegative,validators.tx_interval]" [(fireInvalidSubmit)]="invalidSubmit" [form]="form" [validation]="validationSelfScan.tx_interval"></app-validation-msg>
        </div>
      </div>

      <div class="ui-g ui-fluid">
        <div class="ui-g-12 ui-md-4">
          <span class="label" [ngClass]="{'required': !validationSelfScan.void_qta_max.nullable}">{{ validationSelfScan.void_qta_max.keyName }}</span>
          <input type="number" min="0" max="{{paramSelfScan.void_qta_max}}" pInputText class="fieldInput" formControlName="void_qta_max"/>
          <app-validation-msg [arrayValidators]="[validators.decimalNotNegative,validators.void_qta_max]" [(fireInvalidSubmit)]="invalidSubmit" [form]="form" [validation]="validationSelfScan.void_qta_max"></app-validation-msg>
        </div>

        <div class="ui-g-12 ui-md-4">
          <span class="label" [ngClass]="{'required': !validationSelfScan.void_val_max.nullable}">{{ validationSelfScan.void_val_max.keyName }}</span>
          <input type="number" min="0" max="{{paramSelfScan.void_val_max}}" pInputText class="fieldInput" formControlName="void_val_max"/>
          <app-validation-msg [arrayValidators]="[validators.decimalNotNegative,validators.void_val_max]" [(fireInvalidSubmit)]="invalidSubmit" [form]="form" [validation]="validationSelfScan.void_val_max"></app-validation-msg>
        </div>
      </div>

      <div class="ui-g ui-fluid">
        <div class="ui-g-12 ui-md-4">
          <span class="label" [ngClass]="{'required': !validationSelfScan.num_valid_check.nullable}">{{ validationSelfScan.num_valid_check.keyName }}</span>
          <input type="number" min="0" max="{{paramSelfScan.num_valid_check}}" pInputText class="fieldInput" formControlName="num_valid_check"/>
          <app-validation-msg [arrayValidators]="[validators.decimalNotNegative,validators.num_valid_check]" [(fireInvalidSubmit)]="invalidSubmit" [form]="form" [validation]="validationSelfScan.num_valid_check"></app-validation-msg>
        </div>
      </div>

      <div class="ui-g ui-fluid">
        <div class="ui-g-12 ui-md-4">
          <span class="label" [ngClass]="{'required': !validationSelfScan.min_tx_check.nullable}">{{ validationSelfScan.min_tx_check.keyName }}</span>
          <input type="number" min="0" max="{{ form.controls.max_tx_check.value-1 }}"  pInputText class="fieldInput" formControlName="min_tx_check"/>
          <app-validation-msg [arrayValidators]="[validators.integerNotNegative,validators.min_tx_check]" [(fireInvalidSubmit)]="invalidSubmit" [form]="form" [validation]="validationSelfScan.min_tx_check"></app-validation-msg> 
        </div>

        <div class="ui-g-12 ui-md-4">
          <span class="label" [ngClass]="{'required': !validationSelfScan.max_tx_check.nullable}">{{ validationSelfScan.max_tx_check.keyName }}</span>
          <input type="number" min="0"  pInputText class="fieldInput" formControlName="max_tx_check"/>
          <app-validation-msg [arrayValidators]="[validators.integerNotNegative,validators.max_tx_check]" [(fireInvalidSubmit)]="invalidSubmit" [form]="form" [validation]="validationSelfScan.max_tx_check" ></app-validation-msg>
        </div>
      </div>

      <div class="ui-g ui-fluid">
        <div class="ui-g-12 ui-md-4">
          <span class="label" [ngClass]="{'required': !validationSelfScan.default_check_chance.nullable}">{{ validationSelfScan.default_check_chance.keyName }}</span>
          <input type="number" min="0" max="{{paramSelfScan.default_check_chance}}" pInputText class="fieldInput" formControlName="default_check_chance"/>
          <app-validation-msg [arrayValidators]="[validators.decimalNotNegative,validators.default_check_chance]" [(fireInvalidSubmit)]="invalidSubmit" [form]="form" [validation]="validationSelfScan.default_check_chance"></app-validation-msg>
        </div>
      </div>


      <div class="ui-g">
        <div class="ui-g-11 ui-md-11 ui-lg-11">
          <h3 class="title">{{ 'self_scan_detail.title' | translate }}</h3>
        </div>
        <div class="ui-g-12 ui-md-12 ">
          <button pButton (click)="aggiungi()" icon="fa fa-plus-circle" iconPos="right" type="button" class="k-generic-btn" label="{{ 'common.add' | translate }}"></button>
        </div>
      </div>

      <div formArrayName="details">
        <div class="ui-g ui-fluid" *ngFor="let detail of details.controls; let i=index" [formGroupName]="i">
          <p-panel class="ui-g-12">
            <p-header>
              <div class="ui-helper-clearfix pull-left">
                <h3 class="title">{{ 'self_scan_detail.title' | translate }}</h3>
              </div>
              <div class="ui-helper-clearfix pull-right">
                <button pButton type="button" (click)="deleteDetail(i, detail)" icon="fa fa-times" class="ui-button-danger btnDelete"></button>
              </div>
            </p-header>
            <div class="ui-g-12  ui-fluid">
              <div class="ui-g-12 ui-md-4">
                <span class="label">{{ validationSelfScanDetails.row_no.keyName }}</span>
                <input disabled type="number" pInputText class="fieldInput" formControlName="row_no"/>
              </div>
              <div class="ui-g-12 ui-md-2">
                <span class="label" [ngClass]="{'required': !validationSelfScanDetails.min.nullable}">{{ validationSelfScanDetails.min.keyName }}</span>
                <input type="number" min="0" max="{{paramSelfScan.min}}" pInputText class="fieldInput" formControlName="min"/>
                <app-validation-msg [arrayValidators]="[validators.decimalNotNegative,validators.min]" [(fireInvalidSubmit)]="invalidSubmit" [form]="detail" [validation]="validationSelfScanDetails.min"></app-validation-msg>
              </div>
              <div class="ui-g-12 ui-md-2">
                <span class="label" [ngClass]="{'required': !validationSelfScanDetails.max.nullable}">{{ validationSelfScanDetails.max.keyName }}</span>
                <input type="number" min="0" max="{{paramSelfScan.max}}" pInputText class="fieldInput" formControlName="max"/>
                <app-validation-msg [arrayValidators]="[validators.decimalNotNegative,validators.max]" [(fireInvalidSubmit)]="invalidSubmit" [form]="detail" [validation]="validationSelfScanDetails.max"></app-validation-msg>
              </div>
              <div class="ui-g-12 ui-md-2">
                <span class="label" [ngClass]="{'required': !validationSelfScanDetails.step.nullable}">{{ validationSelfScanDetails.step.keyName }}</span>
                <input type="number" min="0" max="{{paramSelfScan.step}}" pInputText class="fieldInput" formControlName="step"/>
                <app-validation-msg [arrayValidators]="[validators.decimalNotNegative,validators.step]" [(fireInvalidSubmit)]="invalidSubmit" [form]="detail" [validation]="validationSelfScanDetails.step"></app-validation-msg>
              </div>

            </div>
            <p-footer class="clearfix">&nbsp;</p-footer>
          </p-panel>
        </div>
      </div>


    </div>
  </div>
</form>



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-self-scan-rules/form-self-scan-rules/form-self-scan-rules.component.html